import * as React from 'react';
import { css, withTheme, Theme } from 'styled-components';
import { Context } from '../../i18n';

const { useContext } = React;

interface IProps {
  theme: Theme;
  isWhirl: boolean;
  onClick: () => void;
}

const FeedbackButton = (props: IProps) => {
  const { theme, onClick, isWhirl } = props;
  const { feedbackFontColor, feedbackIconColor } = theme;
  const { feedback_text } = useContext(Context);
  if (!feedback_text) return null;
  return (
    <a
      className="secsdk_captcha_feedback"
      onClick={onClick}
      css={css`
        display: inline-flex;
        align-items: center;
        float: left;
        margin-left: ${(isWhirl ? 15 : 10) / 100}em;
      `}
    >
      <span
        className="secsdk_captcha_feedback--icon"
        css={css`
          display: inline-block;
          width: 0.2em;
          height: 0.2em;
          line-height: 0.2em;
          vertical-align: middle;
          margin-right: 0.02em;
          svg {
            display: block;
            width: 100%;
            height: 100%;
          }
        `}
      >
        <svg width="20px" height="20px" x="0px" y="0px" viewBox="0 0 20 20">
          <g transform="translate(3.000000, 3.000000)">
            <path
              fill={feedbackIconColor}
              d="M7,13.5c3.6,0,6.5-2.9,6.5-6.5S10.6,0.5,7,0.5S0.5,3.4,0.5,7S3.4,13.5,7,13.5z M7,12.5
                          C4,12.5,1.5,10,1.5,7S4,1.5,7,1.5S12.5,4,12.5,7S10.1,12.5,7,12.5z"
            />
            <path
              fill={feedbackIconColor}
              d="M6.5,4v3.5C6.5,7.8,6.7,8,7,8s0.5-0.2,0.5-0.5V4c0-0.3-0.2-0.5-0.5-0.5S6.5,3.7,6.5,4z"
            />
            <path
              fill={feedbackIconColor}
              d="M7,10.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6S6.4,9.5,6.4,9.9
                          C6.4,10.2,6.7,10.5,7,10.5z"
            />
          </g>
        </svg>
      </span>
      <span
        className="secsdk_captcha_feedback--text"
        css={css`
          font-size: 0.14em !important;
          color: ${feedbackFontColor};
        `}
      >
        {feedback_text.feedback}
      </span>
    </a>
  );
};

export default withTheme(FeedbackButton);
